export const selectMonthlyReport = ({ monthlyReport: { item } }) => item;

export const selectMonthlyReportIsLoading = ({ monthlyReport: { isLoading } }) => isLoading;

export const selectMonthlyReportError = ({ monthlyReport: { error } }) => error;

export default {
  selectMonthlyReport,
  selectMonthlyReportIsLoading,
  selectMonthlyReportError,
};

